"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSplittedZones = exports.NEW_ZONES = void 0;

var _towns_2020_ = _interopRequireDefault(require("./redirect_data/towns_2020_04"));

var _towns_2020_2 = _interopRequireDefault(require("./redirect_data/towns_2020_05"));

var _zones_2019_ = _interopRequireDefault(require("./redirect_data/zones_2019_07"));

var _towns_2021_ = _interopRequireDefault(require("./redirect_data/towns_2021_04"));

var _towns_2021_2 = _interopRequireDefault(require("./redirect_data/towns_2021_08"));

var _towns_2021_10_ = _interopRequireDefault(require("./redirect_data/towns_2021_10_20"));

var _towns_2021_11_ = _interopRequireDefault(require("./redirect_data/towns_2021_11_02"));

var _towns_2022_02_ = _interopRequireDefault(require("./redirect_data/towns_2022_02_08"));

var _towns_2022_03_ = _interopRequireDefault(require("./redirect_data/towns_2022_03_02"));

var _towns_2022_04_ = _interopRequireDefault(require("./redirect_data/towns_2022_04_05"));

var _towns_2022_05_ = _interopRequireDefault(require("./redirect_data/towns_2022_05_05"));

var _towns_2022_06_ = _interopRequireDefault(require("./redirect_data/towns_2022_06_06"));

var _towns_2022_09_ = _interopRequireDefault(require("./redirect_data/towns_2022_09_01"));

var _towns_2022_09_2 = _interopRequireDefault(require("./redirect_data/towns_2022_09_22"));

var _towns_2022_10_ = _interopRequireDefault(require("./redirect_data/towns_2022_10_11"));

var _towns_2022_11_ = _interopRequireDefault(require("./redirect_data/towns_2022_11_09"));

var _towns_2022_12_ = _interopRequireDefault(require("./redirect_data/towns_2022_12_12"));

var _towns_2023_01_ = _interopRequireDefault(require("./redirect_data/towns_2023_01_31"));

var _towns_2023_03_ = _interopRequireDefault(require("./redirect_data/towns_2023_03_15"));

var _towns_2023_05_ = _interopRequireDefault(require("./redirect_data/towns_2023_05_18"));

var _towns_2023_07_ = _interopRequireDefault(require("./redirect_data/towns_2023_07_05"));

var _towns_2023_09_ = _interopRequireDefault(require("./redirect_data/towns_2023_09_18"));

var _towns_2023_12_ = _interopRequireDefault(require("./redirect_data/towns_2023_12_12"));

var _towns_2024_01_ = _interopRequireDefault(require("./redirect_data/towns_2024_01_31"));

var _towns_2024_03_ = _interopRequireDefault(require("./redirect_data/towns_2024_03_26"));

var _towns_2024_06_ = _interopRequireDefault(require("./redirect_data/towns_2024_06_13"));

var _towns_2024_06_2 = _interopRequireDefault(require("./redirect_data/towns_2024_06_18"));

var _towns_2024_06_3 = _interopRequireDefault(require("./redirect_data/towns_2024_06_26"));

var _towns_2024_09_ = _interopRequireDefault(require("./redirect_data/towns_2024_09_12"));

var _towns_2024_09_2 = _interopRequireDefault(require("./redirect_data/towns_2024_09_13"));

var _towns_2024_09_3 = _interopRequireDefault(require("./redirect_data/towns_2024_09_14"));

var _towns_2024_11_ = _interopRequireDefault(require("./redirect_data/towns_2024_11_08"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NEW_ZONES = _objectSpread({}, _zones_2019_["default"], {}, _towns_2020_["default"], {}, _towns_2020_2["default"], {}, _towns_2021_["default"], {}, _towns_2021_2["default"], {}, _towns_2021_10_["default"], {}, _towns_2021_11_["default"], {}, _towns_2022_02_["default"], {}, _towns_2022_03_["default"], {}, _towns_2022_04_["default"], {}, _towns_2022_05_["default"], {}, _towns_2022_06_["default"], {}, _towns_2022_09_["default"], {}, _towns_2022_09_2["default"], {}, _towns_2022_10_["default"], {}, _towns_2022_11_["default"], {}, _towns_2022_12_["default"], {}, _towns_2023_01_["default"], {}, _towns_2023_03_["default"], {}, _towns_2023_05_["default"], {}, _towns_2023_07_["default"], {}, _towns_2023_09_["default"], {}, _towns_2023_12_["default"], {}, _towns_2024_01_["default"], {}, _towns_2024_03_["default"], {}, _towns_2024_06_["default"], {}, _towns_2024_06_2["default"], {}, _towns_2024_06_3["default"], {}, _towns_2024_09_["default"], {}, _towns_2024_09_2["default"], {}, _towns_2024_09_3["default"], {}, _towns_2024_11_["default"]);

exports.NEW_ZONES = NEW_ZONES;

var getSplittedZones = function getSplittedZones(urlHashkeys, mapZones) {
  var newHashKeys = [];
  var toRedirect = false;
  urlHashkeys.map(function (oldHkey) {
    var zonesFromThatHash = mapZones[oldHkey];

    if (zonesFromThatHash) {
      toRedirect = zonesFromThatHash.filter(function (z) {
        return z.primary === true;
      }).length > 0;
      zonesFromThatHash.map(function (zone) {
        newHashKeys.push(zone.hkey);
      });
    } else {
      newHashKeys.push(oldHkey);
    }
  });
  newHashKeys = _toConsumableArray(new Set(newHashKeys));
  return {
    newHashKeys: newHashKeys,
    toRedirect: toRedirect
  };
};

exports.getSplittedZones = getSplittedZones;